import styled from 'styled-components';

export const StyledMetric = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
`;
